import React, { useState, useEffect } from 'react';
import { FaFacebookF, FaLinkedinIn, FaTiktok } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import './Team.css';

const teamMembers = [
  { id: 1, name: "Isaac Musa", role: "Founder & CEO", image: "/images/team/team-1.jpg", initials: "IM", facebook: "#", twitter: "#", tiktok: "#", linkedin: "#" },
  { id: 2, name: "Apollo Mwangi", role: "Electrical Installation & Network Expert", image: "/images/team/team-2.jpg", initials: "AM", facebook: "#", twitter: "#", tiktok: "#", linkedin: "#" },
  { id: 3, name: "Felister Mbithe", role: "Electrical Installation & CCTV Specialist", image: "/images/team/team-3.jpg", initials: "FM", facebook: "#", twitter: "#", tiktok: "#", linkedin: "#" },
  { id: 4, name: "Moses Wainaina", role: "Solar & Electronics Engineer", image: "/images/team/team-4.jpg", initials: "MW", facebook: "#", twitter: "#", tiktok: "#", linkedin: "#" },
  { id: 5, name: "Brian Mwenyeke", role: "CCTV & Solar System Specialist", image: "/images/team/team-5.jpg", initials: "BM", facebook: "#", twitter: "#", tiktok: "#", linkedin: "#" }
];

const Team = () => {
  const [activeMember, setActiveMember] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imgError, setImgError] = useState({});

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => setActiveMember(prev => (prev + 1) % teamMembers.length), 4000);
    return () => clearInterval(interval);
  }, [isPaused]);

  const activeTeammate = teamMembers[activeMember];
  const scrollMembers = [...teamMembers, ...teamMembers];

  const handleImgError = (id) => setImgError(prev => ({ ...prev, [id]: true }));

  const renderImage = (member, isBig) => (
    <div className={`team-img ${isBig ? 'big' : ''}`} onClick={() => !imgError[member.id] && setSelectedImage(member.image)}>
      {!imgError[member.id] ? (
        <img src={process.env.PUBLIC_URL + member.image} alt={member.name} onError={() => handleImgError(member.id)} />
      ) : (
        <div className="avatar-fallback show">{member.initials}</div>
      )}
      <div className="team-social">
        <a href={member.facebook} target="_blank" rel="noopener noreferrer" className="social-link"><FaFacebookF /></a>
        <a href={member.twitter} target="_blank" rel="noopener noreferrer" className="social-link"><FaXTwitter /></a>
        <a href={member.tiktok} target="_blank" rel="noopener noreferrer" className="social-link"><FaTiktok /></a>
        <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="social-link"><FaLinkedinIn /></a>
      </div>
    </div>
  );

  const renderSmallCard = (member, index) => (
    <div key={member.id} className={`team-small-card ${index === activeMember ? 'active' : ''}`} onClick={() => { setActiveMember(index); setIsPaused(true); }}>
      {!imgError[member.id] ? (
        <img src={process.env.PUBLIC_URL + member.image} alt={member.name} onError={() => handleImgError(member.id)} />
      ) : (
        <div className="small-avatar-fallback show">{member.initials}</div>
      )}
      <span className="small-card-name">{member.name.split(' ')[0]}</span>
    </div>
  );

  return (
    <section className="team-section">
      <div className="team-container">
        <div className="team-header">
          <h4 className="team-subtitle">Our Team</h4>
          <h1 className="team-title">Meet Our Skilled Professionals</h1>
          <p className="team-description">Our skilled team of certified electricians and technicians are dedicated to providing top-quality electrical services for your home and business.</p>
        </div>

        <div className="team-desktop" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}>
          <div className="team-scroll">
            {scrollMembers.map((member, index) => (
              <div className="team-item" key={`${member.id}-${index}`}>
                {renderImage(member, false)}
                <div className="team-info"><h4>{member.name}</h4><p>{member.role}</p></div>
              </div>
            ))}
          </div>
        </div>

        <div className="team-mobile" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}>
          <div className="team-big-card">
            {renderImage(activeTeammate, true)}
            <div className="team-info"><h4>{activeTeammate.name}</h4><p>{activeTeammate.role}</p></div>
          </div>
          <div className="team-small-cards">{teamMembers.map((member, index) => renderSmallCard(member, index))}</div>
        </div>
      </div>

      {selectedImage && (
        <div className="team-lightbox" onClick={() => setSelectedImage(null)}>
          <button className="lightbox-close" onClick={() => setSelectedImage(null)}>✕</button>
          <img src={process.env.PUBLIC_URL + selectedImage} alt="Team member" className="lightbox-image" onClick={e => e.stopPropagation()} />
        </div>
      )}
    </section>
  );
};

export default Team;
